window.$ = window.jQuery = require('jquery');

var settings = require('../config/settings.js');

require('angular');
var app = require('./app.js');
app.constant('settings', settings);
app.constant('_', require('lodash/core'));
app.constant('_', require('lodash'));

app.constant('messages', require('../../resource/dutch.json'));

app.config(require('./config.js'));

// Allow inclusion of all urls
app.config(['$sceDelegateProvider', function ($sceDelegateProvider) {
  'use strict';
  $sceDelegateProvider.resourceUrlWhitelist(['**']);
}]);

// Use hashBang for search engines
app.config(['$locationProvider', function ($locationProvider) {
  'use strict';
  $locationProvider.hashPrefix('!');
}]);

// Initialize curricula
app.run(require('./initialize.js'));

// Configuation that has to do with router
app.run(['$transitions', '$state', '$notification', '$location', 'ngMeta', '$window', function ($transitions, $state, $notification, $location, ngMeta, $window) {
  'use strict';

  // Init metadata service
  ngMeta.init();

  // Show 404 when state not found
  $transitions.onError({}, function ($transition) {
    if ($transition.error().type !== 5) {
      console.warn($transition.error());
      $state.go('notFound');
    }
  });

  // Scroll to top on page change
  // Clear notifications on page change
  $transitions.onFinish({}, function (transition) {
    $window.scrollTo(0, 0);
  });

}]);

app.run(['$anchorScroll', function ($anchorScroll) {
  'use strict';
  $anchorScroll.yOffset = 130; // always scroll by 130 extra pixels
}]);

// Compile directive: Allow angular to change HTML on the fly
app.directive('compile', ['$compile', 'termHelper', function ($compile, termHelper) {
  'use strict';
  var sanitize = require('sanitize-html');

  function sanitizeHtml(string) {
    string = sanitize(string, {
      allowedTags: ['b', 'em', 'strong', 'a', 'li', 'ul', 'ol', 'p', 'br', 'table', 'tr', 'td', 'tbody'],
      allowedAttributes: {
        a: ['href', 'target'],
        li: [],
        ul: ['class'],
        table: ['class'],
        tr: [],
        td: ['colspan', 'rowspan']
      },
      selfClosing: ['br'],
      transformTags: {
        ul: function (tagName, attribs) {
          return {
            tagName: 'ul',
            attribs: {
              class: 'list-basic-disc'
            }
          };
        },
        br: function (tagName, attribs) {
          return {
            tagName: 'p'
          };
        },
        table: function (tagName, attribs) {
          return {
            tagName: 'table',
            attribs: {
              class: 'table table-striped'
            }
          };
        },
        a: sanitize.simpleTransform('a', {target: '_blank'}, true)
      }
    });
    return string;
  }

  var filterHtml = function (string) {
    string = sanitize(string, {
      allowedTags: ['br', 'ul', 'ol', 'li', 'b']
    });
    return string;
  };

  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      const useTerm = scope.$eval(attrs.compileTerm);
      const noHtml = scope.$eval(attrs.CompileNoHtml);
      let prevValue;
      scope.$watch(
        function (scope) {
          return scope.$eval(attrs.compile);
        },
        function (value) {
          if(prevValue !== value) {
            if (typeof value !== 'undefined') {
              if (noHtml) {
                value = filterHtml(value);
              } else {
                value = sanitizeHtml(value);
              }
              if (useTerm) {
                if (useTerm === 'highlight') {
                  value = termHelper.highlightTerm(value);
                } else {
                  value = termHelper.replaceTerm(value);
                }
              } else {
                value = termHelper.removeTerm(value);
              }
              element.html(value);
              $compile(element.contents())(scope);
            }
          }
        }
      );
    }
  };
}]);

var sanitize = require('sanitize-html');

// Filter to cut text to an fixed char width
app.filter('cut', function () {
  'use strict';

  function noHtml(string) {
    string = sanitize(string, {
      allowedTags: []
    });
    return string;
  }

  return function (value, wordwise, max, tail) {
    var lastspace;
    if (!value) { return ''; }
    value = noHtml(value);
    max = parseInt(max, 10);
    if (!max) { return value; }
    if (value.length <= max) { return value; }

    value = value.substr(0, max);
    if (wordwise) {
      lastspace = value.lastIndexOf(' ');
      if (lastspace !== -1) {
        // Also remove . and , so its gives a cleaner result.
        if (value.charAt(lastspace - 1) === '.' || value.charAt(lastspace - 1) === ',') {
          lastspace = lastspace - 1;
        }
        value = value.substr(0, lastspace);
      }
    }

    return value + (tail || '…');
  };
});

app.filter('noHtml', function () {
  'use strict';
  return function (string) {
    return sanitize(string, {
      allowedTags: []
    });
  };
});

app.service('$notification', ['ngToast', function (ngToast) {
  'use strict';
  var that = {};

  that.error = function (message) {
    ngToast.danger({
      content: message,
      dismissButton: true,
      dismissOnTimeout: false
    });
    console.error(message);
  };

  that.warning = function (message) {
    ngToast.warning({
      content: message,
      dismissButton: true,
      dismissOnTimeout: false
    });
    console.warn(message);
  };

  that.success = function (message) {
    ngToast.success({
      content: message,
      dismissButton: true,
      dismissOnTimeout: false
    });
    console.log(message);
  };

  that.info = function (message) {
    ngToast.info({
      content: message,
      dismissButton: true,
      dismissOnTimeout: false
    });
    console.log(message);
  };

  that.clear = function () {
    ngToast.dismiss();
  };
  return that;
}]);

app.config(['ngToastProvider', function (ngToast) {
  'use strict';
  ngToast.configure({
    verticalPosition: 'bottom',
    horizontalPosition: 'right',
    maxNumber: 3
  });
}]);

module.exports = app;



// WEBPACK FOOTER //
// ./web/js/app/index.js